import Instruction from './Instruction';

export interface LSystemInstructions {
    /**
     * Set the depth of the instructions. Implementations may ignore this
     * if it is beyond their capacity
     */
    setDepth: (depth: number) => void;
    /**
     * Get the next instruction.
     */
    next: () => Instruction | null;
}

export type SymbolToInstruction = {
    forward: string[];
};

const constantMap: { [key: string]: Instruction } = {
    r: Instruction.COLOR_RED,
    o: Instruction.COLOR_ORANGE,
    y: Instruction.COLOR_YELLOW,
    g: Instruction.COLOR_GREEN,
    b: Instruction.COLOR_BLUE,
    p: Instruction.COLOR_PURPLE,
    k: Instruction.COLOR_BLACK,
    '[': Instruction.PUSH,
    ']': Instruction.POP,
    '-': Instruction.LEFT,
    '+': Instruction.RIGHT,
    '^': Instruction.UP,
    v: Instruction.DOWN,
    '\\': Instruction.TILT_LEFT,
    '/': Instruction.TILT_RIGHT,
};

const mapSymbolToInstruction = (symbol: string, map: SymbolToInstruction): Instruction | null => {
    if (map.forward.includes(symbol)) {
        return Instruction.FORWARD;
    }

    return constantMap[symbol] || null;
};

export { mapSymbolToInstruction };
